import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";

export default function Loading({
  open = true,
  label = "Laden...",
  opacity = 0.4,
  zIndexOffset = 2,
  spinnerSize = 80,
  spinnerColor,            // defaults to theme.palette.secondary.main
  labelColor = "#fff",
  backdropSx = {},
}) {
  const theme = useTheme();
  if (!open) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: `rgba(0,0,0,${opacity})`,
        zIndex: (t) => t.zIndex.modal + zIndexOffset,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(1px)",
        ...backdropSx,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
        <ThreeDots
          height={spinnerSize}
          width={spinnerSize}
          color={spinnerColor || theme.palette.secondary.main}
          visible
        />
        {label && (
          <Typography variant="body2" sx={{ color: labelColor }}>
            {label}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
